import { BodyText } from "@/components/ui/Text";

export const EscalateToMdMessage = () => {
  return (
    <div className="flex flex-col gap-2 justify-center items-center">
      <BodyText size="sm" textColor="primary" className="text-center">
        Thank you for your patience! A licensed clinician will be with you as
        soon as possible.
      </BodyText>
      <BodyText size="sm" textColor="primary" className="text-center">
        <BodyText size="sm" textColor="error">
          IMPORTANT:{" "}
        </BodyText>
        If you are experiencing a medical emergency, please call 911 or go to
        your nearest emergency room immediately.
      </BodyText>
    </div>
  );
};
